import { NamedError } from '../utils/Errors';

export enum FrontDoorFileUploadErrors {
  NetworkError = 'NetworkError',
  UnsupportedFileFormat = 'UnsupportedFileFormat',
  WaitTimeoutReached = 'WaitTimeoutReached',
  InternalServerError = 'InternalServerError'
}

export class FrontDoorFileUploadError extends NamedError<FrontDoorFileUploadErrors> {
  constructor(name: FrontDoorFileUploadErrors, message: string) {
    super(name, message)
  }
}